/**
 * 認証状態を表すアイコン（tbody > tr > td のセル内で使用）
 */

type Props = {
  active: boolean;
};

const AuthIcon = ({ active }: Props) => {
  return active ? (
    <div className='size-[24px]'>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M9.5501 18.0001L3.8501 12.3001L5.2751 10.8751L9.5501 15.1501L18.7251 5.9751L20.1501 7.4001L9.5501 18.0001Z'
          fill='#61BD6D'
        />
      </svg>
    </div>
  ) : (
    <div className='size-[24px]'>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g opacity='0.5'>
          <path
            d='M5.25 12.8625V11.1125H18.75V12.8625H5.25Z'
            fill='#292929'
          />
        </g>
      </svg>
    </div>
  );
};

export default AuthIcon;
